import React, { useState } from "react";
import styled from "styled-components";
import { Subscription } from "react-apollo";
import scales from "assets/img/scale-weight.svg";
import SUBSCRIBE_TO_SENSOR_CHANGES from "../graphql/subscriptions/subscribeToSensorMeasurementChanges.js";

// Styled components
const SensorContainer = styled.div`
  transition: all 0.3s ease-in;
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: flex-start;
  flex-wrap: nowrap;
  z-index: 2023;
  top: ${({ monitoringExpanded, expansionHeight }) => (monitoringExpanded ? `calc(${expansionHeight} + 120px)` : "120px")};
  width: 290px;
  right: -230px;
  max-height: ${({ monitoringExpanded, expansionHeight }) => (monitoringExpanded ? `calc(95vh - ${expansionHeight} - 120px)` : "alc(95vh - 120px)")}c;
  transform: ${({ showScales }) => (showScales ? "translate(-230px)" : "translate(0px)")};
  background-color: rgba(0, 0, 0, 0);
  display: ${({ controlMenuOpen }) => (controlMenuOpen ? "none" : "flex")};
`;

const ScaleIcon = styled.div`
  background-color: #2f4050;
  order: 1;
  padding: 10px;
  z-index: 2025;
  max-height: 60px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.8);
  clip-path: inset(0px 0px -10px -10px);
  cursor: pointer;
`;

const ScalesContainer = styled.div`
  background-color: #2f4050;
  order: 2;
  padding: 10px;
  z-index: 2023;
  max-width: 230px;
  width: 230px;
  text-align: center;
  border-radius: 0 0 0 10px;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.8);
  clip-path: inset(0px 0px -10px -10px);
  color: #fff;

  p {
    color: #fff;
    text-align: center;
    margin: 20px;
    font-size: 15px;
    font-family: "Rubik", sans-serif;
  }
`;

const ScalesList = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  border-top: 1px lightgray solid;
  border-bottom: 1px lightgray solid;
  padding-top: 5px;
  max-height: ${({ controlMenuOpen }) => controlMenuOpen ? "calc(95vh - 460px)" : "calc(95vh - 200px)"};
`;

const Span = styled.span`
  width: 180px;
  border-radius: 10px;
  background-color: #fff;
  color: #2f4050;
  display: inline-block;
  margin-bottom: 20px;
`;

const H5 = styled.h5`
  margin-top: 3px;
  margin-bottom: 5px;
`;

const H2 = styled.h2`
  margin-top: 5px;
  margin-bottom: 0px;
  font-weight: bold;
`;

const SensorSubscription = ({ id, name, unit }) => {
  return (
    <Subscription
      subscription={SUBSCRIBE_TO_SENSOR_CHANGES}
      fetchPolicy="no-cache"
      variables={{
        id
      }}
    >
      {({ data }) => <Sensor data={data} name={name} unit={unit} />}
    </Subscription>
  );
};

const Sensor = ({ data, name, unit }) => {
  const value = data ? data.subscribeToSensorMeasurementChanges.toFixed(1) : "0.0";
  const info = unit ? `${value} ${unit}` : value > 0 ? "ON" : "OFF";
  return (
    <Span>
      <H2>
        { info }
      </H2>
      <H5>{ name }</H5>
    </Span>
  );
};

// Main Component
export const Sensors = ({
  sensorsList,
  controlMenuOpen,
  monitoringExpanded,
  expansionHeight,
  onClick,
}) => {
  const [showScales, setShowScales] = useState(false);

  return (
    <SensorContainer
      controlMenuOpen={controlMenuOpen}
      showScales={showScales}
      monitoringExpanded={monitoringExpanded}
      expansionHeight={expansionHeight}
      onClick={onClick}
    >
      <ScaleIcon onClick={() => setShowScales(!showScales)}>
        <img src={scales} alt="Scale icon" width="40px" height="40px" />
      </ScaleIcon>
      <ScalesContainer>
        <p>BALANÇAS</p>
        <ScalesList controlMenuOpen={controlMenuOpen}>
          {sensorsList.map(({ id, name, unit }) => (
            <SensorSubscription key={id} id={id} name={name} unit={unit} />
          ))}
        </ScalesList>
      </ScalesContainer>
    </SensorContainer>
  );
};
